import type { BacklogHttpResponse } from "../contracts/api/BacklogHttpResponse";
import type { BacklogResponseNoContent as BacklogResponseNoContentContract } from "../contracts/api/BacklogResponseNoContent";

export class BacklogResponseNoContent
	implements BacklogResponseNoContentContract
{
	constructor(
		private options: {
			response: BacklogHttpResponse;
		},
	) {}
	getStatus(): number {
		return this.options.response.getStatus();
	}
}
